import { Helmet } from 'react-helmet-async'
import { SettingsForm } from '@/components/account/settings-form'
import { DeleteAccountSection } from '@/components/account/delete-account-section'
import { useAuth } from '@/hooks/useAuth'
import { Loader2 } from 'lucide-react'
import { getPageTitle } from '@/lib/branding'

export function AccountSettingsPage() {
  const { customerProfile, isLoading } = useAuth()

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-12">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    )
  }

  if (!customerProfile) {
    return (
      <div className="max-w-2xl mx-auto">
        <p className="text-muted-foreground">Settings not available. Please try signing in again.</p>
      </div>
    )
  }

  return (
    <>
      <Helmet>
        <title>{getPageTitle('Settings')}</title>
      </Helmet>
      <div className="max-w-2xl mx-auto space-y-8">
        <div>
          <h1 className="text-2xl font-bold">Settings</h1>
          <p className="text-muted-foreground mt-1">
            Manage your account preferences
          </p>
        </div>

        <SettingsForm
          emailNotifications={customerProfile.email_notifications}
          profileId={customerProfile.id}
        />
        <DeleteAccountSection />
      </div>
    </>
  )
}
